import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../i18n';

const PrivacyPolicy = () => {
  const { t } = useI18n();

  const section = (titleKey, content) => (
    <section className="max-w-3xl mx-auto px-4 py-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-3">{t(titleKey)}</h2>
      {content}
    </section>
  );

  const Bullet = ({ children }) => (
    <li className="pl-2 ml-4 list-disc text-gray-700">{children}</li>
  );

  return (
    <div className="pt-20 bg-gray-50 min-h-screen">
      <motion.section
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-gradient-to-r from-blue-800 to-blue-900 text-white py-14 text-center"
      >
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-3">{t('privacy.hero.title')}</h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto">{t('privacy.hero.subtitle')}</p>
          <p className="text-sm mt-2 opacity-80">{t('privacy.effective')}</p>
        </div>
      </motion.section>

      {section('privacy.sections.intro.title', (
        <>
          <p className="text-gray-700">{t('privacy.sections.intro.p1')}</p>
          <p className="text-gray-700 mt-3">{t('privacy.sections.intro.p2')}</p>
        </>
      ))}

      {section('privacy.sections.info.title', (
        <ul className="space-y-2">
          <Bullet>{t('privacy.sections.info.items.account')}</Bullet>
          <Bullet>{t('privacy.sections.info.items.usage')}</Bullet>
          <Bullet>{t('privacy.sections.info.items.device')}</Bullet>
          <Bullet>{t('privacy.sections.info.items.cookies')}</Bullet>
        </ul>
      ))}

      {section('privacy.sections.use.title', (
        <ul className="space-y-2">
          <Bullet>{t('privacy.sections.use.items.provide')}</Bullet>
          <Bullet>{t('privacy.sections.use.items.improve')}</Bullet>
          <Bullet>{t('privacy.sections.use.items.communicate')}</Bullet>
          <Bullet>{t('privacy.sections.use.items.security')}</Bullet>
        </ul>
      ))}

      {section('privacy.sections.sharing.title', (
        <ul className="space-y-2">
          <Bullet>{t('privacy.sections.sharing.items.providers')}</Bullet>
          <Bullet>{t('privacy.sections.sharing.items.compliance')}</Bullet>
          <Bullet>{t('privacy.sections.sharing.items.business')}</Bullet>
        </ul>
      ))}

      {section('privacy.sections.cookies.title', (
        <p className="text-gray-700">{t('privacy.sections.cookies.text')}</p>
      ))}

      {section('privacy.sections.retention.title', (
        <p className="text-gray-700">{t('privacy.sections.retention.text')}</p>
      ))}

      {section('privacy.sections.security.title', (
        <p className="text-gray-700">{t('privacy.sections.security.text')}</p>
      ))}

      {section('privacy.sections.children.title', (
        <p className="text-gray-700">{t('privacy.sections.children.text')}</p>
      ))}

      {section('privacy.sections.yourRights.title', (
        <p className="text-gray-700">{t('privacy.sections.yourRights.text')}</p>
      ))}

      {section('privacy.sections.contact.title', (
        <p className="text-gray-700">{t('privacy.sections.contact.text')}</p>
      ))}

      {section('privacy.sections.changes.title', (
        <p className="text-gray-700">{t('privacy.sections.changes.text')}</p>
      ))}

      {section('privacy.sections.sms.title', (
        <>
          <p className="text-gray-700">{t('privacy.sections.sms.p1')}</p>
          <ul className="space-y-2 mt-3">
            <Bullet>{t('privacy.sections.sms.items.appointments')}</Bullet>
            <Bullet>{t('privacy.sections.sms.items.payments')}</Bullet>
            <Bullet>{t('privacy.sections.sms.items.service')}</Bullet>
            <Bullet>{t('privacy.sections.sms.items.voicemail')}</Bullet>
          </ul>
          <p className="text-gray-700 mt-3 font-semibold">{t('privacy.sections.sms.frequency')}</p>
          <p className="text-gray-700 mt-1">{t('privacy.sections.sms.costs')}</p>
          <p className="text-gray-700 mt-1 font-semibold">{t('privacy.sections.sms.optout')}</p>
          <p className="text-gray-700 mt-1">{t('privacy.sections.sms.noshare')}</p>
          <p className="text-gray-700 mt-3 text-sm">{t('privacy.sections.sms.contact')}</p>
        </>
      ))}

      <div className="h-8" />
    </div>
  );
};

export default PrivacyPolicy;
